import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "styled-components";
import { Tooltip } from "../floating";
import { AmazonLogoReverse, WalmartLogo } from "../icon/components";
import { MarketplaceBadge } from "../marketplaceBadge/MarketplaceBadge";
export const marketImages = {
    w: _jsx(WalmartLogo, {}),
    a: _jsx(AmazonLogoReverse, {}),
    WALMART: _jsx(WalmartLogo, {}),
    AMAZON: _jsx(AmazonLogoReverse, {}),
};
const marketRelation = {
    a: "AM",
    w: "WM",
    AMAZON: "AM",
    WALMART: "WM",
};
const defaultOnImageClick = (e) => e.stopPropagation();
export const ProductImage = ({ product, market = "a", tooltipContent, size = "100", onImageClick = defaultOnImageClick, tooltipOptions, }) => {
    return (_jsx(Tooltip, { colorType: "light", content: tooltipContent ?? (_jsx(TooltipImageWrapper, { children: _jsx(TooltipImage, { src: product?.imageSrc }) })), disabled: !tooltipContent && !product?.imageSrc, small: true, ...tooltipOptions, children: _jsxs(Wrapper, { "$size": size, href: product?.href, target: "_blank", onClick: onImageClick, children: [_jsxs(ImageWrapper, { "$emptyBadge": market == null || size === "50", children: [_jsx(Icon, { icon: faExternalLink }), size === "50" && _jsx(StyledMarketplaceBadge, { platform: marketRelation[market] }), product?.imageSrc ? _jsx(Image, { src: product.imageSrc }) : _jsx(NoImageIcon, {})] }), market && size !== "50" && _jsx(Badge, { children: market && marketImages[market] })] }) }));
};
const StyledMarketplaceBadge = styled(MarketplaceBadge) `
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 16px;
  height: 16px;
  font-size: 10px;
`;
const Icon = styled(FontAwesomeIcon) `
  font-size: 16px;
  color: ${(p) => p.theme.systemColors.blue600};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 1;
`;
export const NoImageIcon = styled(FontAwesomeIcon).attrs({ icon: faImage }) `
  font-size: 20px;
  color: ${(p) => p.theme.systemColors.grey200};
`;
const ImageWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  border: 1px solid ${(p) => p.theme.systemColors.grey200};
  border-bottom: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: #fff;

  ${(p) => p.$emptyBadge &&
    css `
      border-radius: 4px;
      border-bottom: 1px solid ${(p) => p.theme.systemColors.grey200};
    `}
  &:before {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(p) => p.theme.systemColors.white};
    content: "";
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 1;
  }
`;
const Image = styled.img `
  display: block;
  max-width: 100%;
  max-height: 100%;
  user-select: none;
`;
const TooltipImageWrapper = styled.div `
  width: 182px;
  height: 182px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TooltipImage = styled.img `
  display: block;
  max-width: 100%;
  max-height: 100%;
`;
const Badge = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 16px;
  background-color: ${(p) => p.theme.systemColors.black};
`;
const themes = {
    50: css `
    ${ImageWrapper} {
      width: 42px;
      height: 42px;
    }
  `,
    100: css `
    ${ImageWrapper} {
      width: 40px;
      height: 40px;
    }
  `,
    150: css `
    ${ImageWrapper} {
      width: 44px;
      height: 44px;
    }
  `,
    200: css `
    ${ImageWrapper} {
      padding: 2px;
      width: 60px;
      height: 64px;
    }
  `,
    400: css `
    ${ImageWrapper} {
      padding: 2px;
      width: 76px;
      height: 80px;
    }
  `,
};
const Wrapper = styled.a `
  position: relative;
  display: inline-block;

  ${(p) => themes[p.$size]};

  &:focus {
    outline: none;
  }

  &:before {
    box-sizing: border-box;
    position: absolute;
    display: none;
    content: "";
    top: -4px;
    left: -4px;
    right: 0;
    bottom: 0;
    height: calc(8px + 100%);
    width: calc(8px + 100%);
    border-radius: 8px;
    border: 2px solid ${(p) => p.theme.systemColors.blue600};
  }

  ${(p) => p.href &&
    css `
      &:hover {
        ${Icon} {
          opacity: 1;
        }

        ${ImageWrapper}:before {
          opacity: 0.8;
        }
      }

      &:active {
        ${ImageWrapper}:before {
          opacity: 1;
        }
      }

      &:focus-visible {
        &:before {
          display: block;
        }
      }
    `}
`;
